export class RecordMapper {
  static mapDetailToList(r) {
    return {
      refHexaId: r.record.refHexaId,
      brandName: r.vehicle.brandLabel,
      modelName: r.vehicle.modelLabel,
      mileage: r.vehicle.mileage,
      recordId: r.record.id,
      originId: r.record.originId,
      statusCarcheck: r.record.statusId,
      registration: r.vehicle.registration,
      // appointmentDate,
      // appointmentTime,
      expertiseStartAt: r.expertise.expertiseStartAt,
      hbs: ([1, 11].includes(r.record.originId) && true) || false,
      recordTypeId: r.record.recordTypeId,
      formSource: r.record.formSource,
    };
  }

  static mapRecordLists(r) {
    return {
      ...r,
      statusCarcheck: (r.statusCarcheck === 3 && r.recordTypeId === 2 && 'counterAppraisalDone') || r.statusCarcheck,
    };
  }

  static mapCoverageRequestDetail(r) {
    // Extract the numeric b2c_market_value and mcclbp we already parse above
    const b2cValue =r.session_vehicle?.vehicle?.vehicle_valuation?.[0]?.b2c_market_value > 0 ? parseInt(r.session_vehicle?.vehicle?.vehicle_valuation?.[0]?.b2c_market_value, 10) : 0;
    const mcclValue = r.session_vehicle?.vehicle?.vehicle_valuation?.[0]?.mcclbp > 0 ? parseInt(r.session_vehicle?.vehicle?.vehicle_valuation?.[0]?.mcclbp, 10) : 0;

    // Decide which value to use as the denominator
    const denominator = b2cValue > 0 ? b2cValue : mcclValue;

    return {
      refHexaId: r.session_vehicle?.file_number,
      brandName: r.session_vehicle?.make,
      modelName: r.session_vehicle?.model,
      firstRegistrationDate: r.session_vehicle?.registration_date,
      mileage: r.session_vehicle?.vehicle?.mileage,
      recordId: r.recordId,
      originId: r.originId,
      salesCreatedAt: r.start_date_time,
      salesEndedAt: r.end_date_time,
      countOffer: r.offer_count,
      b2cMarketValue: b2cValue,
      mcclbp: mcclValue,
      bestSaleOfferAmount: r.best_offer > 0 ? parseInt(r.best_offer, 10) : 0,
      rplCoverageRequest:
        r.best_offer > 0 && denominator > 0 ? parseInt((r.best_offer / denominator) * 100, 10) : '',
      currentWinner: r.firstName && r.lastName && `${r.firstName} ${r.lastName}`,
      carProfile: r.profile,
      statusCarcheck: r.statusId,
      hbs: ([1, 11].includes(r.originId) && true) || false,
      recordTypeId: r.recordTypeId,
      formSource: r.formSource,
      purchaseOrder: r.purchaseOrder,
      hideMerchantInfo: r.hideMerchantInfo,
      displayOnlyWinnersInfo: r.displayOnlyWinnersInfo,
    };
  }
}
